import Vue from 'vue'
import AjaxLoader from './AjaxLoader'
import Tickbox from './Tickbox'
import BackButton from './BackButton'
import InputNumber from './InputNumber'
import formatNumberFilter from '../../filters/formatNumberFilter'
import i18nFilter from "../../filters/i18nFilter";

Vue.component('ajax-loader', AjaxLoader)
Vue.component('tickbox', Tickbox)
Vue.component('back-button', BackButton)
Vue.component('input-number', InputNumber)
Vue.filter('formatNumber', formatNumberFilter)
Vue.filter('i18n', i18nFilter)



// WEBPACK FOOTER //
// ./src/components/common/index.js